import { MaterialIcon } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { ASSET_TYPE_CONTAINER, ASSET_TYPE_PHONE } from '../../../constants/asset';
import {
  VEHICLE_TYPE_BUS,
  VEHICLE_TYPE_CAR,
  VEHICLE_TYPE_MACHINERY,
  VEHICLE_TYPE_MOTORCYCLE,
  VEHICLE_TYPE_PICKUP,
  VEHICLE_TYPE_TRACT,
  VEHICLE_TYPE_TRAILER,
  VEHICLE_TYPE_TRUCK,
  VEHICLE_TYPE_VAN,
} from '../../../constants/vehicle';
import { useStyles } from '../../../hooks/useStyles';
import { AssetType } from '../../../types/asset';
import { VehicleType } from '../../../types/vehicle';
import AssetIcon from '../../icons/AssetIcon';
import BusIcon from '../../icons/BusIcon';
import CarIcon from '../../icons/CarIcon';
import MotorcycleIcon from '../../icons/MotorcycleIcon';
import PickupIcon from '../../icons/PickupIcon';
import TractIcon from '../../icons/TractIcon';
import TrailerIcon from '../../icons/TrailerIcon';
import TruckIcon from '../../icons/TruckIcon';
import VanIcon from '../../icons/VanIcon';

type Props = {
  vehicleType?: VehicleType;
  color?: string;
  assetType?: AssetType;
  iconSize?: number;
};

function VehicleIcon({ vehicleType, color, assetType, iconSize }: Props) {
  const { theme } = useStyles();
  const vehicleColor = color === '#F2EEF2' ? theme.colors.contentPrimary : color;

  return (
    <>
      {vehicleType === VEHICLE_TYPE_TRACT && (
        <TractIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {vehicleType === VEHICLE_TYPE_CAR && (
        <CarIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {assetType === ASSET_TYPE_CONTAINER && <AssetIcon size={iconSize} />}
      {vehicleType === VEHICLE_TYPE_BUS && (
        <BusIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {vehicleType === VEHICLE_TYPE_TRAILER && (
        <TrailerIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {vehicleType === VEHICLE_TYPE_MOTORCYCLE && (
        <MotorcycleIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {vehicleType === VEHICLE_TYPE_PICKUP && (
        <PickupIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {vehicleType === VEHICLE_TYPE_TRUCK && (
        <TruckIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {vehicleType === VEHICLE_TYPE_VAN && (
        <VanIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {/* Fix me!! add custom icon for VEHICLE_TYPE_MACHINERY */}
      {vehicleType === VEHICLE_TYPE_MACHINERY && (
        <TrailerIcon
          color={vehicleColor}
          size={iconSize}
        />
      )}
      {/* Fix me!! add custom icon for ASSET_TYPE_PHONE */}
      {assetType === ASSET_TYPE_PHONE && <MaterialIcon name={'phone_iphone'} />}
    </>
  );
}

export default memo(VehicleIcon);
